import { Injectable } from '@angular/core';
import { PopupdisplayComponent } from 'app/popupdisplay/popupdisplay.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AlertmessageService 
{
  dialogRef: MatDialogRef<PopupdisplayComponent>;
  private subject = new Subject<any>();
  constructor(public dialog: MatDialog,public _router:Router) 
  { 

  }
  confirm(message: string,siFn:()=>void,noFn:()=>void)
          {
            console.log("on confirm");
            this.setConfirmation(message,siFn,noFn);
          }
          setConfirmation(message: string,siFn:()=>void,noFn:()=>void) {
            let that = this;
            console.log("set confirm");
            this.subject.next({ type: "confirm",
                        text: message,
                        siFn:
                        function()
                        {
                            that.subject.next(); //this will close the modal
                            siFn();
                        },
                        noFn:function()
                        {
                            that.subject.next();
                            noFn();
                        }
                     });

                 }

          getMessage(): Observable<any> {
             return this.subject.asObservable();
          }
          openConfirmationDialog(Msg,checking?:Boolean) 
          {
            
            this.dialogRef = this.dialog.open(PopupdisplayComponent, {
              height: '140px',
              width: '900px',
              data: {},
              disableClose: false
            });
            this.dialogRef.componentInstance.confirmMessage = Msg;
        
            this.dialogRef.afterClosed().subscribe(result => {            
              this.dialogRef = null;
            });
          }

          openConfirmationDialogTimeOut(Msg, checking?: Boolean) {
 
            this.dialogRef = this.dialog.open(PopupdisplayComponent, {
              // height: '75px',
              // width: '300px',
              //height: '140px',
              //width: '600px',
              data: {},
              disableClose: false
        
            });
           
            this.dialogRef.componentInstance.confirmMessage = Msg;
            console.log("test");
            this.dialogRef.afterClosed().subscribe(result => {
              if (result) {
                if (checking)
                console.log("test");
                 // this._router.navigate(['/'])
                // this._authService.logout();
                     this._router.navigate(['']).then(() => {
                           window.location.reload();
                        });
                // do confirmation actions
                
              }
        
              this.dialogRef = null;
            });
          }
          openConfirmationDialogSignuUp(Msg, checking?: Boolean) {

            this.dialogRef = this.dialog.open(PopupdisplayComponent, {
              // height: '75px',
              // width: '300px',
              //height: '140px',
              //width: '600px',
              data: {},
              disableClose: false
            });
            this.dialogRef.componentInstance.confirmMessage = Msg;
            console.log("test");
            this.dialogRef.afterClosed().subscribe(result => {
              if (result) {
                if (checking)
                console.log("test");
                  this._router.navigate(['/'])
                // do confirmation actions
              }
        
              this.dialogRef = null;
            });
          }
}
